import React from 'react'
import { Slide } from '@mui/material'
import { useLocation } from 'react-router'
import { styles } from './styles'
import { Direction } from './types'

import { TRANSITION_DURATION } from './types'

export const AnimatedPage = ({
  children,
  direction,
  resetBackDirection
}: {
  children: React.ReactElement<any, any>
  direction: Direction
  resetBackDirection: () => void
}) => {
  const location = useLocation()

  const containerRef = React.useRef(null)

  return (
    <Slide
      direction={direction}
      key={location.key}
      in
      timeout={TRANSITION_DURATION}
      mountOnEnter
      unmountOnExit
      addEndListener={(node, done) => {
        done()
        resetBackDirection()
      }}
      container={containerRef.current}
    >
      <div style={styles.animatedContent}>{children}</div>
    </Slide>
  )
}
